import script from "./DrugIndicationOverrideDialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./DrugIndicationOverrideDialog.vue?vue&type=script&setup=true&lang=ts"

import "./DrugIndicationOverrideDialog.vue?vue&type=style&index=0&id=339cc812&lang=scss&scoped=true"
import "./DrugIndicationOverrideDialog.vue?vue&type=style&index=1&id=339cc812&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-339cc812"]])

export default __exports__